import styles from "./buttons.module.css";

const PrimaryButton = ({ text, onClick, className = "", type = "button", disabled }) => {
	return (
		<button
			className={`${styles.primaryButton} btn ${className}`}
			onClick={onClick}
			type={type}
			disabled={disabled}
			>
			{text}
			
		</button>
	);
};

export default PrimaryButton;
